export default __webpack_public_path__ + "static/media/cross.036ffd29.svg";